export const Mobile: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.325"
      height="40.2"
      viewBox="0 0 23.325 40.2"
      {...props}
    >
      <g transform="translate(-2351.542 -1333.749)">
        <g transform="translate(2361.989 1368.309)">
          <path
            d="M2455.945,1679.621a1.216,1.216,0,1,1,1.216-1.215A1.217,1.217,0,0,1,2455.945,1679.621Z"
            transform="translate(-2454.729 -1677.19)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(2351.642 1333.849)">
          <path
            d="M2370.844,1373.849h-15.28a3.927,3.927,0,0,1-3.922-3.922v-32.156a3.927,3.927,0,0,1,3.922-3.922h15.28a3.927,3.927,0,0,1,3.922,3.922v32.156A3.927,3.927,0,0,1,2370.844,1373.849Zm-15.28-38.595a2.52,2.52,0,0,0-2.517,2.517v32.156a2.52,2.52,0,0,0,2.517,2.517h15.28a2.52,2.52,0,0,0,2.517-2.517v-32.156a2.52,2.52,0,0,0-2.517-2.517Z"
            transform="translate(-2351.642 -1333.849)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(2359.988 1337.24)">
          <path
            d="M2440.214,1369.044H2435.5a.7.7,0,1,1,0-1.405h4.717a.7.7,0,1,1,0,1.405Z"
            transform="translate(-2434.794 -1367.639)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
        <g transform="translate(2351.866 1365.626)">
          <path
            d="M2375.85,1651.859H2354.58a.7.7,0,1,1,0-1.405h21.271a.7.7,0,1,1,0,1.405Z"
            transform="translate(-2353.877 -1650.454)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.2"
          />
        </g>
      </g>
    </svg>
  );
};
